var React = require('react');

function Sort (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M288 288H32c-28.4 0-42.8 34.5-22.6 54.6l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c20-20.1 5.7-54.6-22.7-54.6zM160 448L32 320h256L160 448zM32 224h256c28.4 0 42.8-34.5 22.6-54.6l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128C-10.7 189.5 3.6 224 32 224zM160 64l128 128H32L160 64z"}));
}

Sort.defaultProps = {"viewBox":"0 0 320 512"};

module.exports = Sort;

Sort.default = Sort;
